import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pie-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pie = _resolveComponent("Pie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_Pie, {
          id: "pie",
          data: _ctx.pieData,
          options: _ctx.pieOpts,
          key: _ctx.key
        }, null, 8, ["data", "options"]))
      : _createCommentVNode("", true)
  ]))
}